<section class="auction-terms">
  <div class="auction-terms__header">
    <span class="auction-terms__header-icon">
      <i class="iconsax" icon-name="tick-circle"></i>
    </span>
    <h2 class="auction-terms__title">
      {{ 'auctions.termsFramework' | translate }}
    </h2>
  </div>

  <div class="auction-terms__grid">
    <article class="auction-terms__item">
      <h3 class="auction-terms__item-title">
        {{ 'auctions.bidLegitimacy' | translate }}
      </h3>
      <p class="auction-terms__item-text">
        {{
          'auctions.bidLegitimacyDesc'
            | translate
              : {
                  amount: auction()?.amount?.value,
                  unit:
                    ('enums.measurements.' + auction()?.amount?.unit | translate),
                  title: (auction()?.title | translateData),
                }
        }}
      </p>
    </article>

    <article class="auction-terms__item">
      <h3 class="auction-terms__item-title">
        {{ 'auctions.shippingDelivery' | translate }}
      </h3>
      <p class="auction-terms__item-text">
        {{
          'auctions.shippingDeliveryDesc'
            | translate
              : {
                  address:
                    (auction()?.delivery_address | translateData) ||
                    (auction()?.product?.delivery_address | translateData) ||
                    '-',
                }
        }}
      </p>
    </article>

    <article class="auction-terms__item">
      <h3 class="auction-terms__item-title">
        {{ 'auctions.qualityVerification' | translate }}
      </h3>
      <p class="auction-terms__item-text">
        {{ 'auctions.qualityVerificationDesc' | translate }}
      </p>
    </article>
  </div>
</section>
